var _path, _path2, _path3, _path4, _path5, _circle, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoChangedTenant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 41,
    viewBox: "0 0 50 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 1.5L23.0069 7.05615L11.9931 1.5L1 7.05615V32.5L11.9931 26.9438L23.0069 32.5L27.9169 30.2212",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 7.05615L34 1.5L45 7.05615V21.0563",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5L11.9937 28.2665",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34 1.5L34.0044 21.6313",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0103 32.9078L23 6.5",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.0361,
    cy: 31.6891,
    r: 8.25,
    stroke: "#CCCCCC",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0361 31.8417C36.0361 33.8664 37.7483 35.5047 39.8642 35.5047C41.98 35.5047 43.6922 33.8664 43.6922 31.8417C43.6922 29.8171 41.9731 28.1787 39.8642 28.1787C39.3152 28.1787 38.7915 28.2888 38.3183 28.4882",
    stroke: "#CCCCCC",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.864 30.0881L37.7275 28.4193L39.7802 26.391",
    stroke: "#CCCCCC",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoChangedTenant);
export default __webpack_public_path__ + "static/media/no-changed-tenant.4b2b1e9545d444f6ecf8b4056781e33d.svg";
export { ForwardRef as ReactComponent };